import {
  DATA_SOURCE,
  DATA_SOURCE_VALUE,
} from '../types/enums/data-source.enum';
import { I18n } from '@app/i18n/strings-keys';

export const DATE_SOURCE_FILTER_OPTIONS = [
  {
    text: I18n.Common.POS,
    value: DATA_SOURCE.POS,
  },
  {
    text: I18n.Common.Portal,
    value: DATA_SOURCE.Portal,
  },
];

export const DATE_SOURCE_WITH_ALL_FILTER_OPTIONS = [
  {
    text: I18n.Common.Portal,
    value: DATA_SOURCE.Portal,
  },
  {
    text: I18n.Common.POS,
    value: DATA_SOURCE.POS,
  },
  {
    text: I18n.Common.All_Sources,
    value: DATA_SOURCE_VALUE.All_Sources,
  },
];
